var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPartialWithdrawal = function SvgPartialWithdrawal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.666 6a4.333 4.333 0 1 1 0 8.667 4.333 4.333 0 0 1 0-8.667Zm0 1.333a3 3 0 1 0 0 6 3 3 0 0 0 0-6Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 12c.368 0 .666.299.666.667a2 2 0 0 1-2 2h-1.333a.667.667 0 0 1 0-1.334h1.333a.666.666 0 0 0 .667-.666c0-.368.299-.667.667-.667ZM14 7.333c.368 0 .666.299.666.667v2a.667.667 0 1 1-1.333 0V8c0-.368.299-.667.667-.667ZM14.068 1.337a.667.667 0 0 1 .598.663v3.333a.667.667 0 1 1-1.333 0V3.61l-2.195 2.196a.667.667 0 1 1-.943-.943l2.195-2.195h-1.724a.667.667 0 0 1 0-1.334H14l.068.004ZM3.333 1.333a.667.667 0 0 1 0 1.334.667.667 0 0 0-.667.666v1.334a.667.667 0 0 1-1.333 0V3.333a2 2 0 0 1 2-2ZM8 1.333a.667.667 0 0 1 0 1.334H6a.667.667 0 0 1 0-1.334h2Z",
    fill: "currentColor"
  })));
};
export { SvgPartialWithdrawal as ReactComponent };